export default "__VITE_ASSET__CXyDtrJu__"